module.exports = __webpack_public_path__ + "img/hamburger-gray.b50d15f0.png";